// Voo remarcado no card do itinerário (mockup aprovado, opção A): o novo leva o selo
// "Remarcado" e a linha "Antes" com o voo que ele substituiu; o voo marcado sem par sai
// esmaecido, com a linha que explica por que o vivo dele sumiu.
import { voucherStatusName } from '@voll-intelligence/domain';
import type { TripStop } from './derive.js';
import { t } from './i18n.js';
import { localDayLabel } from './labels.js';
import { VoucherStatusBadge } from './primitives.js';

type StopService = TripStop['service'];

/** O back office está trocando este voo e o novo ainda não chegou. Pelo nome de status, e
 *  não pela tag crua: o cancelamento pedido vence a alteração, como na pill. */
export function isChangeInProgress(service: StopService): boolean {
  return voucherStatusName(service.voucher) === 'CHANGE_REQUESTED';
}

/** O selo do voo novo, no polo do card acima do status. */
export function RebookedBadge({ service }: Readonly<{ service: StopService }>) {
  if (!service.rebookedFrom) return null;
  return <VoucherStatusBadge variant="progress" labelKey="trips.panel.rebooked" />;
}

/** "Antes: LATAM 3340 · 28 out · 07:10" — o voo substituído, no mesmo formato de dia e
 *  hora do card; sem data a linha não sai. A linha do voo marcado sem par diz que ele
 *  saiu do acompanhamento ao vivo. */
export function RebookingNote({ service }: Readonly<{ service: StopService }>) {
  const from = service.rebookedFrom;
  if (from) {
    const date = localDayLabel(from.departAt);
    if (!date) return null;
    return (
      <span className="tp-stop__sub tp-stop__before">
        {t('trips.panel.rebookedBefore', {
          flight: from.flightLabel,
          date,
          time: from.departTime,
        })}
      </span>
    );
  }
  if (!isChangeInProgress(service)) return null;
  return <span className="tp-stop__sub tp-stop__note">{t('trips.panel.changeNoLive')}</span>;
}
